import { Validator } from 'fluentvalidation-ts';
import { beBetweenInclusive, haveDecimalPlaces } from '../../../../../validators/stringValidators';
import { maximumDefaultTemperatureAboveInDegreesCelsius } from '../../rooms/heatLoss/roomHeatLossDefaults';
import { getDistinctFloorLevelCodes, UnitFormModel } from '../unitFormModel';

export type UnitRoofElementFormModel = {
  roofElementId: number | null;
  name: string;
  roofThermalTransmittance: string;
  skylightThermalTransmittance: string;
  defaultTemperatureAboveInDegreesCelsius: string;
};

export const getDefaultUnitRoofElementFormModels = (
  unit: UnitFormModel,
  externalAirTemperatureInDegreesCelsius: string,
): Array<UnitRoofElementFormModel> => {
  const distinctFloorLevelCodes = getDistinctFloorLevelCodes(unit);

  if (distinctFloorLevelCodes.length > 1) {
    return [
      {
        ...getDefaultUnitRoofElementFormModel(externalAirTemperatureInDegreesCelsius),
        name: 'Roof Element 1',
      },
      { ...getDefaultUnitRoofElementFormModel(), name: 'Ceiling Element 1' },
    ];
  } else {
    return [{ ...getDefaultUnitRoofElementFormModel(externalAirTemperatureInDegreesCelsius), name: 'Roof Element 1' }];
  }
};

export const getDefaultUnitRoofElementFormModel = (
  externalAirTemperatureInDegreesCelsius?: string,
): UnitRoofElementFormModel => ({
  roofElementId: null,
  name: '',
  roofThermalTransmittance: '',
  skylightThermalTransmittance: '',
  defaultTemperatureAboveInDegreesCelsius:
    externalAirTemperatureInDegreesCelsius ?? maximumDefaultTemperatureAboveInDegreesCelsius.toString(),
});

export class UnitRoofElementFormModelValidator extends Validator<UnitRoofElementFormModel> {
  constructor(heatLossIsRequired: boolean) {
    super();

    this.ruleFor('name')
      .notEmpty()
      .maxLength(100);

    this.ruleFor('roofThermalTransmittance')
      .must(beBetweenInclusive(0, 99999999))
      .must(haveDecimalPlaces(3));

    this.ruleFor('roofThermalTransmittance')
      .notEmpty()
      .when(() => heatLossIsRequired);

    this.ruleFor('skylightThermalTransmittance')
      .must(beBetweenInclusive(0, 99999999))
      .must(haveDecimalPlaces(3));

    this.ruleFor('skylightThermalTransmittance')
      .notEmpty()
      .when(() => heatLossIsRequired);

    this.ruleFor('defaultTemperatureAboveInDegreesCelsius').must(haveDecimalPlaces(1));

    this.ruleFor('defaultTemperatureAboveInDegreesCelsius')
      .notEmpty()
      .when(() => heatLossIsRequired);
  }
}
